import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS} from '@/queryClient'
import {httpSendMail} from '@/features/mailer/http/mailer.http'
import {SendMailResponse} from '@/features/mailer/types'

interface UseSendMailOptions {
    onSuccess?: (data: SendMailResponse) => void
    onError?: (error: unknown) => void
}

export const useSendMail = ({onSuccess, onError}: UseSendMailOptions = {}) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: [MUTATION_KEYS.SEND_MAIL],
        mutationFn: httpSendMail,
        onSuccess: data => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.MAILER_BATCHES]})
            onSuccess?.(data)
        },
        onError
    })
}
